import React, { useState, useEffect } from "react";
import { Form, Row, Col, message, Select, Card, Space } from "antd";
import CustomTitle from "../../../components/CustomTitle.jsx";
import CustomSelect from "../../../components/CustomSelect.jsx";
import alertIcon from "../../../assets/images/alertGroup.svg";
import truckIcon from "../../../assets/images/truck.svg";
import locationIcon from "../../../assets/images/location.svg";
import emptyState from "../../../assets/images/emptyState.svg";
import clockIcon from "../../../assets/images/clock.svg";
import CustomInput from "../../../components/CustomInput.jsx";
import { useToken } from "../../../common/helper";
import { useImperativeHandle, forwardRef } from "react";
import { useSpin } from "../../../components/SpinContext.js";
import CustomParagraph from "../../../components/CustomParagraph.jsx";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import {
  fetchAllLocations,
  selectLocationState,
} from "../../../reudx-toolkit/slice/LocationSlice";
import { useDispatch, useSelector } from "react-redux";
import { GetProducts, SendNotification } from "../../../api's/onboarding.js";
import StepsHeading from "./StepsHeading.jsx";
import FrequencySelectorHorizontal from "./FrequencySelectorHorizontal.jsx";
import CheckboxSelector from "../../../components/CheckBoxSelector.jsx";
import { isValidPhoneNumber } from "libphonenumber-js";

const NotificationSetup = forwardRef(
  ({ onNext, drawerOpen, form, notificationData }, ref) => {
    const { decodedUserToken } = useToken();
    const dispatch = useDispatch();
    const { locationList } = useSelector(selectLocationState);
    let usermail = decodedUserToken()?.email;
    let timezone = decodedUserToken()?.user_time_zone;
    const [productList, setProductList] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [step, setStep] = useState(1);
    const [selectedType, setSelectedType] = useState(null);
    const { showSpin, hideSpin } = useSpin();
    const { token, removeToken } = useToken();
    const [selectedFrequency, setSelectedFrequency] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const navigate = useNavigate();
    const [selectedUserGroup, setSelectedUserGroup] = useState([]);
    const changedByList = [
      { value: "15 minutes", label: "15 minutes" },
      { value: "30 minutes", label: "30 minutes" },
      { value: "1 hour", label: "1 hour" },
      { value: "Over 2 hours", label: "Over 2 hours" },
    ];

    const notificationTypes = [
      {
        id: "CRITICAL_ALERT",
        label: "Critical / At-Risk Alert",
        icon: alertIcon,
        description:
          "An alert noting an issue that has potentially or could lead to a compromised product",
      },
      {
        id: "PICKUP_DELIVERY",
        label: "Pickup / Delivery Confirmation",
        icon: truckIcon,
        description:
          "Notification when there has been a successful pickup or delivery",
      },
      {
        id: "AT_LOCATION",
        label: "Location",
        icon: locationIcon,
        description:
          "Notification when a product is at a specific location (e.g., a warehouse)",
      },
      {
        id: "ETA_BASED",
        label: "ETA",
        icon: clockIcon,
        description: "Notification when projected ETA moves by a set time",
      },
    ];
    useImperativeHandle(ref, () => ({
      completeStep: handleSubmit,
    }));
    const handleUserGroupChange = (newValues) => {
      setSelectedUserGroup(newValues);
    };

    const handleTypeSelect = (id) => {
      const selected = notificationTypes.find((t) => t.id === id);
      setSelectedType(selected);
      setStep(2);
      form.resetFields();
      setSelectedProducts([]);
      setSelectedOption(null);
      setSelectedFrequency(null);
      setSelectedUserGroup(null);
    };

    const renderNotificationCard = (type, onClick, isSelected = false) => (
      <Card
        key={type.id}
        hoverable
        style={{
          marginBottom: "5px",
          borderRadius: "12px",
          border: "2px solid #E8E8E8",
          boxShadow: "none",
          transition: "all 0.2s ease-in-out",
          backgroundColor: isSelected ? "#F5F5F5" : undefined,
        }}
        onClick={onClick}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#F5F5F5";
        }}
        onMouseLeave={(e) => {
          if (!isSelected) e.currentTarget.style.backgroundColor = "white";
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",

            position: type.id === "ETA_BASED" ? "relative" : "initial",
            top: type.id === "ETA_BASED" ? "5px" : "initial",
          }}
        >
          <img
            src={type.icon}
            alt={type.label}
            style={{
              marginLeft: "6px",
              width: "24px",
              height: type.id === "CRITICAL_ALERT" ? "50px" : "24px",
              objectFit: "contain",
            }}
            onError={(e) => (e.target.style.display = "none")}
          />
          <div>
            <CustomParagraph
              color="#000"
              text={type.label}
              fontSize="14px"
              fontWeight="600"
              style={{
                position: type.id === "ETA_BASED" ? "relative" : "initial",
                top: type.id === "ETA_BASED" ? "2px" : "initial",
              }}
              marginBottom={5}
            />
            <CustomParagraph
              style={{ position: "relative", top: "-3px" }}
              color="#4B4B4B"
              text={type.description}
              fontSize="12px"
              marginBottom={0}
            />
          </div>
        </div>
      </Card>
    );
    const renderTypeSpecificContent = (typeId) => {
      switch (typeId) {
        case "CRITICAL_ALERT":
          return (
            <Form.Item>
              <CustomTitle
                text="Alert type"
                fontSize="14px"
                fontWeight="600"
                lineHeight="16px"
                color="black"
                marginBottom="10px"
              />
              <CheckboxSelector
                selectedValues={selectedUserGroup}
                op
                onChange={handleUserGroupChange}
                options={[
                  {
                    value: "Critical",
                    label: "Critical alert",
                    description:
                      "An alert that is indicative of potential product compromise",
                  },
                  {
                    value: "At-risk",
                    label: "At-risk alert",
                    description:
                      "An alert that warns of a potential issue that may escalate into a critical alert",
                  },
                ]}
              />
            </Form.Item>
          );

        case "PICKUP_DELIVERY":
          return (
            <Form.Item>
              <CustomTitle
                text="Type"
                fontSize="14px"
                fontWeight="600"
                lineHeight="16px"
                color="black"
                marginBottom="10px"
              />
              <CheckboxSelector
                selectedValues={selectedUserGroup}
                onChange={handleUserGroupChange}
                options={[
                  {
                    value: "pickup",
                    label: "Pickup",
                    description:
                      "Notification when there has been a successful pickup",
                  },
                  {
                    value: "delivery",
                    label: "Delivery",
                    description:
                      "Notification when there has been a successful delivery",
                  },
                ]}
              />
            </Form.Item>
          );
        case "AT_LOCATION":
          return (
            <Col span={24} style={{ marginTop: "20px" }}>
              <CustomTitle
                text="Location"
                fontSize="14px"
                fontWeight="600"
                lineHeight="16px"
                color="black"
                marginBottom="5px"
              />

              <Form.Item
                name="facility_type"
                rules={[{ message: "Select a type" }]}
              >
                <CustomSelect
                  width="100%"
                  placeholder="Select..."
                  options={
                    Array.isArray(locationList)
                      ? locationList.map((product) => ({
                          value: product?.id,
                          label: product?.name,
                        }))
                      : []
                  }
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  height="36px"
                  border="none"
                  placeholderColor="#5E5E5E"
                />
              </Form.Item>
            </Col>
          );

        case "ETA_BASED":
          return (
            <Col span={24} style={{ marginTop: "20px" }}>
              <CustomTitle
                text="Changed by"
                fontSize="14px"
                fontWeight="600"
                lineHeight="16px"
                color="black"
                marginBottom="5px"
              />
              <Form.Item
                name="changed_by"
                rules={[{ message: "Select a type" }]}
              >
                <CustomSelect
                  width="100%"
                  placeholder="Select..."
                  options={changedByList}
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  height="36px"
                  border="none"
                  placeholderColor="#5E5E5E"
                />
              </Form.Item>
            </Col>
          );
        default:
          return null;
      }
    };

    const handleSelectChange = (value) => {
      setSelectedOption(value);
      if (value === "MOBILE" || value === "WHATSAPP") {
        form.setFieldsValue({ notification_channel: "" });
      } else {
        form.setFieldsValue({ notification_channel: usermail });
      }
    };

    const unauthorize = (error) => {
      if (error && error?.status === 401) {
        removeToken();
        navigate("/login");
      }
    };
    const fetchProductLists = () => {
      showSpin();
      GetProducts(token)
        .then((res) => {
          const data = res?.data ? res.data : null;
          if (data) {
            if (data?.data?.is_success) {
              let res = data.data.data;
              if (res) {
                console.log("resproduc", res);
                setProductList(res);
              }
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    };
    const handleSubmit = () => {
      return new Promise(async (resolve) => {
        try {
          const values = await form.validateFields();

          if (!selectedType) {
            message.error("Please select a notification type.");
            return resolve(false);
          }

          if (
            (selectedType?.id === "CRITICAL_ALERT" ||
              selectedType?.id === "PICKUP_DELIVERY") &&
            !selectedUserGroup
          ) {
            message.error("Please select type");
            return resolve(false);
          }

          const isSpecialType =
            selectedType?.id === "ETA_BASED" ||
            selectedType?.id === "AT_LOCATION";

          const payload = {
            alert_type: selectedType?.id,
            is_critical: isSpecialType
              ? false
              : selectedUserGroup.includes("Critical"),
            is_at_risk: isSpecialType
              ? false
              : selectedUserGroup.includes("At-risk"),
            is_pickup_confirmation: isSpecialType
              ? false
              : selectedUserGroup.includes("pickup"),
            is_delivery_confirmation: isSpecialType
              ? false
              : selectedUserGroup.includes("delivery"),
            location: values.facility_type || null,
            change_by: values.changed_by || null,
            products: values.products.includes("all_products")
              ? productList.map((product) => product.id)
              : values.products || [],
            frequency: values.frequency,
            time_1: values.send_at_1 ? values.send_at_1.format("h:mma") : null,
            time_2: values.send_at_2 ? values.send_at_2.format("h:mma") : null,
            day: values.day_of_week || null,
            notification_method: values.notification_method,
            notification_channel: values.notification_channel,
            created_by: decodedUserToken()?.id,
            create_self: true,
          };

          showSpin();
          SendNotification(token, payload, null)
            .then((res) => {
              const data = res?.data || null;
              if (data?.data?.is_success) {
                form.resetFields();
                message.success(data?.data?.message);
                onNext(payload);
                resolve(true)
              } else {
                message.error(data?.data?.message);
                resolve(false);
              }
            })
            .catch((error) => {
              unauthorize(error);
              resolve(false);
            })
            .finally(() => {
              hideSpin();
            });
        } catch (error) {
          console.error("Validation or payload prep failed:", error);
          resolve(false);
        }
      });
    };

    useEffect(() => {
      if (dispatch) {
        dispatch(fetchAllLocations({ token: token, toggle: false }));
      }
    }, [dispatch]);
    useEffect(() => {
      if (usermail) {
        form.setFieldsValue({
          notification_channel: usermail,
        });
      }
    }, [usermail]);

    useEffect(() => {
      fetchProductLists();
    }, []);
    useEffect(() => {
      setStep(1);
    }, [drawerOpen]);

    useEffect(() => {
      if (step === 1) {
        form.resetFields();
        setSelectedOption(null);
      }
    }, [step]);

    useEffect(() => {
      if (drawerOpen) {
        form.resetFields();
        setSelectedOption(null);
        setSelectedType(null);
      }
    }, [drawerOpen]);

    return (
      <Form
        className="custom-form form-item"
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div className="large-steps-content">
          <StepsHeading
            fontSize="32px"
            textFontSize="16px"
            heading="Tell us how you’d like to receive notifications"
            text="Finally, let’s set your first notification so you can be notified about key shipment events. More advanced options are available in Settings."
          />

          <div
            style={{ display: "flex", height: "100%", position: "relative" }}
          >
            <div style={{ width: "40%", paddingRight: "16px" }}>
              <div
                style={{
                  flex: 1,
                  paddingBottom: "20px",
                  paddingTop: "18px",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
                className="custom-scrollbar"
              >
                <div className="custom-card">
                  <CustomParagraph
                    marginBottom={"5px"}
                    text="Choose a notification type"
                    fontSize="18px"
                    fontWeight={700}
                  />
                  <Space
                    direction="vertical"
                    size={12}
                    style={{ width: "100%" }}
                  >
                    {notificationTypes.map((type) =>
                      renderNotificationCard(
                        type,
                        () => handleTypeSelect(type.id),
                        selectedType?.id === type.id
                      )
                    )}
                  </Space>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "1px",
                backgroundColor: "#E0E0E0",
                marginLeft: "16px",
                marginRight: "30px",
              }}
            />

            <div style={{ width: "40%", position: "relative" }}>
              {selectedType ? (
                <div
                  style={{
                    flex: 1,
                    paddingBottom: "20px",
                    paddingTop: "18px",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                  }}
                  className="custom-scrollbar"
                >
                  <div className="custom-card">
                    <div style={{ marginTop: "16px" }}>
                      {renderTypeSpecificContent(selectedType?.id)}
                    </div>
                  </div>

                  <Col span={24}>
                    <Form.Item
                      className="custom-input form-input-style"
                      label="Products to receive notifications for"
                      name="products"
                      style={{ marginBottom: "0px" }}
                      rules={[
                        {
                          required: true,
                          message: "Please select at least one product",
                        },
                      ]}
                    >
                      <Select
                      className="custom-product-select"
                        showSearch={false}
                        mode="multiple"
                        placeholder="Select..."
                        optionLabelProp="label"
                        value={selectedProducts}
                        defaultValue={selectedProducts}
                        onChange={(value) => {
                          if (value.includes("all_products")) {
                            setSelectedProducts(["all_products"]);
                            form.setFieldsValue({ products: ["all_products"] });
                          } else {
                            setSelectedProducts(value);
                            form.setFieldsValue({ products: value });
                          }
                        }}
                        style={{
                          minHeight: "36px",
                          border: "0px",
                          backgroundColor: "#F3F3F3",
                          color: "#5E5E5E",
                          borderRadius: "8px",
                          lineHeight: "38px",
                          width: "100%",
                        }}
                      >
                        {Array.isArray(productList) &&
                          productList.length > 0 && (
                            <Select.Option
                              value="all_products"
                              label="All Products"
                            >
                              All Products
                            </Select.Option>
                          )}

                        {Array.isArray(productList) &&
                          productList.map((product) => (
                            <Select.Option
                              key={product.id}
                              value={product.id}
                              label={product.name}
                              disabled={selectedProducts.includes(
                                "all_products"
                              )}
                            >
                              {product.name}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <FrequencySelectorHorizontal
                    setSelectedFrequency={setSelectedFrequency}
                    selectedFrequency={selectedFrequency}
                    form={form}
                    timezone={timezone}
                  />

                  <Row style={{ width: "100%" }}>
                    <Col span={24}>
                      <Form.Item
                        className="custom-input label-14px"
                        label="Notify via"
                        name="notification_method"
                        rules={[
                          {
                            required: true,
                            message: "Please select a notification method",
                          },
                        ]}
                      >
                        <CustomSelect
                          placeholder="Select"
                          onChange={handleSelectChange}
                          width="100%"
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#4B4B4B"
                          options={[
                            { value: "MOBILE", label: "SMS" },
                            { value: "EMAIL", label: "Email" },
                            { value: "SLACK", label: "Slack" },
                            { value: "TEAMS", label: "Teams" },
                            { value: "WHATSAPP", label: "WhatsApp" },
                          ]}
                        />
                      </Form.Item>
                    </Col>

                    {selectedOption && (
                      <Col span={24}>
                        <CustomTitle
                          text={
                            selectedOption === "MOBILE" ||
                            selectedOption === "WHATSAPP"
                              ? "Your Phone number"
                              : "Email"
                          }
                          fontSize="12px"
                          fontWeight="600"
                          lineHeight="16px"
                          color="black"
                        />
                        <Form.Item
                          name="notification_channel"
                          className="custom-input label-14px"
                          rules={
                            selectedOption === "EMAIL"
                              ? []
                              : [...(selectedOption === "WHATSAPP" || selectedOption === "MOBILE"
                                    ? [{
                                          // validator: (_, value) => {
                                          //   if (!value) {
                                          //     return Promise.reject(
                                          //       `Please enter ${selectedOption.toLowerCase()} number`
                                          //     );}
                          
                                          //   const digitsOnly = value.replace(/\D/g, "");
                                          //   if (digitsOnly.length >= 10) {
                                          //     return Promise.resolve();
                                          //   }
                                          //   return Promise.reject("Please enter a valid phone number");
                                          // },
                                           validator: (_, value) => {
                                                                  if (!value || value.trim() === '') {
                                                                    return Promise.reject(new Error(`Please enter ${selectedOption.toLowerCase()} number`)); // Reject if empty
                                                                  }
                                                                  try {
                                                                    // Use libphonenumber to validate
                                                                    if (isValidPhoneNumber(value)) {
                                                                      return Promise.resolve();
                                                                    } else {
                                                                      return Promise.reject(new Error('Invalid phone number'));
                                                                    }
                                                                  } catch (error) {
                                                                    return Promise.reject(new Error('Invalid phone number'));
                                                                  }
                                                                }
                                          
                                          ,},]
                                    : [{
                                          required: true,
                                          message:
                                            "Please enter " +
                                            (selectedOption === "MOBILE" || selectedOption === "WHATSAPP"
                                              ? "mobile number"
                                              : "value"),
                                        },]),]}>
                                          
                          {selectedOption === "MOBILE" ||
                          selectedOption === "WHATSAPP" ? (
                            <PhoneInput
                              country="us"
                              value={form.getFieldValue("notification_channel")}
                              onChange={(
                                value,
                                countryData,
                                e,
                                formattedValue
                              ) =>
                                form.setFieldsValue({
                                  notification_channel: formattedValue,
                                })
                              }
                              inputStyle={{
                                width: "100%",
                                height: "36px",
                                background: "#F3F3F3",
                                borderRadius: "8px",
                                border: "none",
                                color: "#5E5E5E",
                              }}
                            />
                          ) : (
                            <CustomInput
                              value={form.getFieldValue("notification_channel")}
                              disabled
                              type="email"
                              placeholder={usermail}
                              height="36px"
                              border="2px solid #E8E8E8"
                              width="100%"
                              bgColor="#fff"
                              textColor="#5E5E5E"
                              borderRadius="8px"
                              placeholderColor="#5E5E5E"
                              lineHeight="38px"
                            />
                          )}
                        </Form.Item>
                      </Col>
                    )}

                    {(selectedOption === "TEAMS" ||
                      selectedOption === "SLACK") && (
                      <Col span={24}>
                        <p
                          style={{
                            color: "#5E5E5E",
                            fontSize: "12px",
                            position: "relative",
                            bottom: "10px",
                            marginBottom:"0px"
                          }}
                        >
                          A ZoomLogi representative will contact you.
                        </p>
                      </Col>
                    )}
                  </Row>
                </div>
              ) : (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                  }}
                >
                  <img
                    src={emptyState}
                    alt="Notification Placeholder"
                    style={{
                      maxWidth: "80%",
                      maxHeight: "80%",
                      paddingLeft: "20%",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Form>
    );
  }
);

export default NotificationSetup;
